import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: true
})
export class TimeAgoPipe implements PipeTransform {

  private readonly MS_PER_DAY = 1000 * 3600 * 24;
  private readonly DAYS_IN_WEEK = 7;
  private readonly DAYS_IN_MONTH = 30;
  private readonly DAYS_IN_YEAR = 365;

  transform(value: Date | string): string {
    if (!value) return '';

    const date = new Date(value);
    if (isNaN(date.getTime())) return ''; // Invalid date

    const now = new Date();
    const diffInDays = Math.floor((now.getTime() - date.getTime()) / this.MS_PER_DAY);

    if (diffInDays === 0) return 'Heute';
    if (diffInDays === 1) return 'Gestern';
    if (diffInDays < this.DAYS_IN_WEEK) return `Vor ${diffInDays} Tagen`;
    if (diffInDays < 2 * this.DAYS_IN_WEEK) return 'Letzte Woche';

    const diffInWeeks = Math.floor(diffInDays / this.DAYS_IN_WEEK);
    if (diffInWeeks < 4) return `Vor ${diffInWeeks} Wochen`;

    const diffInMonths = Math.floor(diffInDays / this.DAYS_IN_MONTH);
    if (diffInMonths === 1) return 'Letzten Monat';
    if (diffInMonths < 12) return `Vor ${diffInMonths} Monaten`;

    const diffInYears = Math.floor(diffInDays / this.DAYS_IN_YEAR);
    if (diffInYears === 1) return 'Letztes Jahr';
    if (diffInYears > 1) return `Vor ${diffInYears} Jahren`;

    return '';
  }
}
